import VueSnotify, { SnotifyPosition as sPosition } from 'vue-snotify'
import * as VueSvgicon from 'vue-svgicon'
import VueAnalytics from 'vue-analytics'
import VueTimeago from 'vue-timeago'
import VueMoment from 'vue-moment'
import Clipboard from 'v-clipboard'
import VTooltip from 'v-tooltip'
import VModal from 'vue-js-modal'
import Vue from 'vue'

import LabelFromFilter from '@/plugins/LabelFromFilter'
import BaseComponents from '@/plugins/BaseComponents'
import EllipsisFilter from '@/plugins/EllipsisFilter'
import ThemeVarsMixin from '@/plugins/ThemeVarsMixin'
import AddressFilter from '@/plugins/AddressFilter'
import LoadingMixin from '@/plugins/LoadingMixin'
import MoneyFilter from '@/plugins/MoneyFilter'
import Validation from '@/plugins/Validation'
import IdleVue from 'idle-vue'
import config from '@/services/config'
import router from './router'
import store from '@/store'
import App from './App.vue'

config.gaId && Vue.use(VueAnalytics, { id: config.gaId, router })

Vue.use(VueSnotify, { toast: { position: sPosition.rightTop, timeout: 4000 } })
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dialog: true })
Vue.use(VueSvgicon, { isOriginalDefault: true })
Vue.use(VueTimeago, { name: 'Timeago', locale: 'en' })
Vue.use(LabelFromFilter)
Vue.use(BaseComponents)
Vue.use(EllipsisFilter)
Vue.use(ThemeVarsMixin)
Vue.use(AddressFilter)
Vue.use(LoadingMixin)
Vue.use(MoneyFilter)
Vue.use(Validation)
Vue.use(VueMoment)
Vue.use(Clipboard)
Vue.use(VTooltip)
Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  store,
  idleTime: 60000,
  startAtIdle: false
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
